import {
    CLEAR_CUSTOMER_DETAILS,
    CLEAR_CUSTOMER_LIST,
    SET_CUSTOMER_DETAILS,
    SET_CUSTOMER_LIST,
    CUSTOMER_CREATE_DIALOG_CLOSE,
    CUSTOMER_CREATE_DIALOG_OPEN,
    CUSTOMER_CREATE_ERROR,
    CUSTOMER_CREATE_ERROR_CLEAR,
    CUSTOMER_CREATE_PENDING,
    CUSTOMER_DETAILS_ERROR,
    CUSTOMER_DETAILS_ERROR_CLEAR,
    CUSTOMER_DETAILS_PENDING,
    CUSTOMER_EDIT_DIALOG_CLOSE,
    CUSTOMER_EDIT_DIALOG_OPEN,
    CUSTOMER_EDIT_ERROR,
    CUSTOMER_EDIT_ERROR_CLEAR,
    CUSTOMER_EDIT_PENDING,
    CUSTOMER_LIST_ERROR,
    CUSTOMER_LIST_ERROR_CLEAR,
    CUSTOMER_LIST_PENDING,
    CUSTOMER_FILTER_DIALOG_OPEN,
    CUSTOMER_FILTER_DIALOG_CLOSE,
    SET_CUSTOMER_FILTER_DATA,
} from "./constants"


const initialState = {

    //-----------------------------|| LIST ||---------------------------------------------------------------
    customerList: null,
    customerListCount: 0,
    isCustomerListPending: false,
    customerListErrorMessage: null,
    //-----------------------------|| FILTER ||-------------------------------------------------------------
    isCustomerFilterDialogOpen: false,
    customerFilterData: null,
    //-----------------------------|| DETAILS ||------------------------------------------------------------
    customerDetails: null,
    isCustomerDetailsPending: false,
    customerDetailsErrorMessage: null,
    //-----------------------------|| CREATE ||-------------------------------------------------------------
    isCustomerCreateDialogOpen: false,
    isCustomerCreatePending: false,
    customerCreateErrorMessage: null,
    //-----------------------------|| EDIT ||---------------------------------------------------------------
    isCustomerEditDialogOpen: false,
    isCustomerEditPending: false,
    customerEditErrorMessage: null,
}

const customers = (state = initialState, action) => {

    switch (action.type) {
        //-----------------------------|| LIST ||---------------------------------------------------------------
        case CUSTOMER_LIST_PENDING: {
            return {
                ...state,
                isCustomerListPending: true,
                customerListErrorMessage: null,
            }
        }

        case SET_CUSTOMER_LIST: {
            const { customerList } = action.payload || {};
            return {
                ...state,
                customerList: customerList['value'],
                customerListCount: customerList['@odata.count'],
                isCustomerListPending: false,
                customerListErrorMessage: null,
            }
        }

        case CUSTOMER_LIST_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                customerListErrorMessage: errorMessage,
                isCustomerListPending: false,
                customerList: null,
                customerListCount: 0,
            }
        }

        case CUSTOMER_LIST_ERROR_CLEAR: {
            return {
                ...state,
                customerListErrorMessage: null,
                isCustomerListPending: false,
            }
        }
        case CLEAR_CUSTOMER_LIST: {
            return {
                ...state,
                customerList: null,
                customerListCount: 0,
            }
        }

        //-----------------------------|| FILTER ||-------------------------------------------------------------
        case CUSTOMER_FILTER_DIALOG_OPEN: {
            return {
                ...state,
                isCustomerFilterDialogOpen: true,
            }
        }
        case CUSTOMER_FILTER_DIALOG_CLOSE: {
            return {
                ...state,
                isCustomerFilterDialogOpen: false,
            }
        }

        case SET_CUSTOMER_FILTER_DATA: {
            const { filter } = action.payload || {};
            return {
                ...state,
                customerFilterData: filter,
            }
        }

        //-----------------------------|| DETAILS ||---------------------------------------------------------------
        case CUSTOMER_DETAILS_PENDING: {
            return {
                ...state,
                isCustomerDetailsPending: true,
                customerDetailsErrorMessage: null,
            }
        }

        case SET_CUSTOMER_DETAILS: {
            const { customerDetails } = action.payload || {};
            return {
                ...state,
                customerDetails: customerDetails,
                isCustomerDetailsPending: false,
                customerDetailsErrorMessage: null,
            }
        }

        case CUSTOMER_DETAILS_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                customerDetailsErrorMessage: errorMessage,
                isCustomerDetailsPending: false,
                customerDetails: null,
            }
        }

        case CUSTOMER_DETAILS_ERROR_CLEAR: {
            return {
                ...state,
                customerDetailsErrorMessage: null,
                isCustomerDetailsPending: false,
            }
        }
        case CLEAR_CUSTOMER_DETAILS: {
            return {
                ...state,
                customerDetails: null,
            }
        }

        //-----------------------------|| CREATE ||---------------------------------------------------------------
        case CUSTOMER_CREATE_DIALOG_OPEN: {
            return {
                ...state,
                isCustomerCreateDialogOpen: true,
            }
        }
        case CUSTOMER_CREATE_DIALOG_CLOSE: {
            return {
                ...state,
                isCustomerCreateDialogOpen: false,
            }
        }

        case CUSTOMER_CREATE_PENDING: {
            return {
                ...state,
                isCustomerCreatePending: true,
                customerCreateErrorMessage: null,
            }
        }

        case CUSTOMER_CREATE_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                customerCreateErrorMessage: errorMessage,
                isCustomerCreatePending: false,
            }
        }

        case CUSTOMER_CREATE_ERROR_CLEAR: {
            return {
                ...state,
                customerCreateErrorMessage: null,
                isCustomerCreatePending: false,
            }
        }

        //-----------------------------|| EDIT ||---------------------------------------------------------------
        case CUSTOMER_EDIT_DIALOG_OPEN: {
            return {
                ...state,
                isCustomerEditDialogOpen: true,
            }
        }
        case CUSTOMER_EDIT_DIALOG_CLOSE: {
            return {
                ...state,
                isCustomerEditDialogOpen: false,
            }
        }

        case CUSTOMER_EDIT_PENDING: {
            return {
                ...state,
                isCustomerEditPending: true,
                customerEditErrorMessage: null,
            }
        }

        case CUSTOMER_EDIT_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                customerEditErrorMessage: errorMessage,
                isCustomerEditPending: false,
            }
        }

        case CUSTOMER_EDIT_ERROR_CLEAR: {
            return {
                ...state,
                customerEditErrorMessage: null,
                isCustomerEditPending: false,
            }
        }

        default: {
            return state;
        }
    }
}

export default customers;